import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "thumbsUpFilled_svg__b",
  d: "M6.265 21.5H3a1.442 1.442 0 0 1-1.5-1.375v-8.25A1.442 1.442 0 0 1 3 10.5h3.407a4.268 4.268 0 0 0 3.439-3.725V2.138l.97-.029h.166c2.036 0 2.955.934 2.955 3.591v3.47h5.91a1.956 1.956 0 0 1 1.556.675 1.821 1.821 0 0 1 .341 1.554l-1.786 8.73a3.156 3.156 0 0 1-2.983 2.371H8.5a2.992 2.992 0 0 1-2.235-1zM3 11.5a.477.477 0 0 0-.5.45v8.1a.477.477 0 0 0 .5.45h2a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
});

var SvgThumbsUpFilled = function SvgThumbsUpFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgThumbsUpFilled;